module.exports = __webpack_public_path__ + "img/placeholder.99137bad.png";